import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deleteDocument } from "../../../firebase/utility";
import toast from "react-hot-toast";

const useAllowedManufacturersHook = () => {
    const { all_allowed_manufacturers } = useSelector((state) => state.redux);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [searchValue, setSearchValue] = useState("");

    const [loading, setLoading] = useState(true);

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this manufacturer?")) {
            await deleteDocument("AllowedManufacturers", id);
            toast.success("Deleted successfully!");
        }
    };

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleEdit = (item) => {
        setSelectedItem(item);
        toggleModal();
    };

    const handleAddNew = () => {
        setSelectedItem(null);
        toggleModal();
    };

    const filteredData = (all_allowed_manufacturers || []).filter(item =>
        item.dnhVendorName?.toLowerCase().includes(searchValue.toLowerCase())
    );

    // Set loading false only when we have data
    useEffect(() => {
        if (all_allowed_manufacturers && all_allowed_manufacturers.length > 0) {
            setLoading(false);
        }
    }, [all_allowed_manufacturers]);

    // Safety timeout to hide loader if no data is returned
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2500);
        return () => clearTimeout(timer);
    }, []);

    return {
        allowedManufacturers: filteredData,
        modalOpen,
        selectedItem,
        toggleModal,
        handleDelete,
        handleEdit,
        handleAddNew,
        searchValue,
        setSearchValue,
        loading,
    };
};

export default useAllowedManufacturersHook;
